export enum ReportTable {
    Reports = "Reports",
    NetworkIdBlacklist = "NetworkIdBlacklist"
}
